module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Skip Debits/Credits #" + _vm._s(_vm.skip.financial_id))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.error !== '') ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.skip.type),
      expression: "skip.type"
    }],
    staticClass: "select is-fullwidth",
    attrs: {
      "name": "type",
      "id": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.skip, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a type")]), _vm._v(" "), (parseInt(_vm.financial.skip_client) == 0) ? _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Client")]) : _vm._e(), _vm._v(" "), (parseInt(_vm.financial.skip_provider) == 0) ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Provider")]) : _vm._e(), _vm._v(" "), (parseInt(_vm.financial.skip_provider) == 0 && parseInt(_vm.financial.skip_client) == 0) ? _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("All")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Reason")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.skip.reason),
      expression: "skip.reason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'textarea': true,
      'is-danger': _vm.errors.has('reason')
    },
    attrs: {
      "name": "reason",
      "id": "reason",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.skip.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.skip, "reason", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('reason')),
      expression: "errors.has('reason')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('reason')))])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    class: {
      'button': true,
      'is-success': true,
      'is-disabled': _vm.errors.any() || _vm.inProgress,
      'is-loading': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.skipAction()
      }
    }
  }, [_vm._v("Skip")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7103d9e2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/finances/SkipDebitsCredits.vue
// module id = 1158
// module chunks = 39